import { render, staticRenderFns } from "./GoodsDetailInfo.vue?vue&type=template&id=0630de9b&scoped=true"
import script from "./GoodsDetailInfo.vue?vue&type=script&lang=js"
export * from "./GoodsDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetailInfo.vue?vue&type=style&index=0&id=0630de9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630de9b",
  null
  
)

export default component.exports